module.exports = __webpack_public_path__ + "img/shield_fail.0e6318a7.svg";